import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_482: DocMigration = {
  maxSchemaVersion: "0.0.482",
  description: "Remove debug boxes from view templates",
  apply(json: any) {
    const { viewTemplates = {} } = json;
    const updatedViewTemplates = {
      ...viewTemplates,
    };

    for (const viewTemplateId in viewTemplates) {
      const viewTemplate = viewTemplates[viewTemplateId];
      if (!viewTemplate.categories.includes("RELAXATION_DEBUG")) {
        continue;
      }

      updatedViewTemplates[viewTemplateId] = {
        ...viewTemplate,
        categories: viewTemplate.categories.filter((category) => category !== "RELAXATION_DEBUG"),
      };
    }

    return {
      ...json,
      viewTemplates: updatedViewTemplates,
    };
  },
};

export default migration_0_0_482;
